import styles from './progressBar.scss';

interface ProgressBarProps {
  className?: string;
  total: number;
  visible: number;
  hasSeenAllProducts: boolean;
  progressBarText: string;
  progressBarDoneText: string;
}

export const ProgressBar = ({
  className,
  total,
  visible,
  hasSeenAllProducts,
  progressBarText,
  progressBarDoneText
}: ProgressBarProps) => {
  const title = hasSeenAllProducts ? progressBarDoneText : progressBarText;

  return (
    <div className={className}>
      <div className={styles.title}>{makeNumbersBold(title)}</div>
      <div className={styles.progressBarOuter}>
        <div
          className={styles.progressBarInner}
          style={{
            transform: `translateX(-${calculateRemainingPercent(total, visible)}%)`
          }}
        />
      </div>
    </div>
  );
};

function makeNumbersBold(string: string) {
  const numbersReg = /\d+/g;

  const parts = string.split(' ');

  return parts.map((part, i) =>
    numbersReg.test(part) ? (
      <span key={i} className={styles.bold}>
        {`${part} `}
      </span>
    ) : (
      `${part} `
    )
  );
}

function calculateRemainingPercent(total: number, visible: number) {
  return 100 - (visible / total) * 100;
}
